<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-form ref="form" v-model="valid" :lazy-validation="true" autocomplete="off">
        <v-card>
          <v-card-title>
            <span class="headline primary--text font-weight-bold">Nuovo Cliente</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="6">
                  <v-text-field v-model="customer.name" label="Nome*" :rules="[rules.required]" required></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="customer.surename" label="Cognome*" :rules="[rules.required]" required>
                  </v-text-field>
                </v-col>

                <v-col cols="6">
                  <v-text-field v-model="customer.phone" label="Telefono*" :rules="[rules.required]" required>
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field v-model="customer.email" label="Email" :rules="[rules.required, rules.validEmail]"></v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-text-field v-model="customer.fiscal_code" label="Codice Fiscale" :rules="[rules.required, rules.validFiscalCode]">
                  </v-text-field>
                </v-col>

                <v-col cols="12">
                  <v-textarea v-model="customer.note" label="Note interne"> </v-textarea>
                </v-col>

                <small>*campo obbligatorio.</small>
                <br />
                <br />
                
                <!-- Documento di identità -->
                <v-expansion-panels style="margin-bottom: 20px">
                  <v-expansion-panel>
                    <v-expansion-panel-header class="primary--text font-weight-bold">Documento di identità
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-container>
                        <v-row>
                          <v-col cols="12">
                            <v-select label="Tipo" v-model="IDDocs.type" :items="types" :rules="[rules.required]"></v-select>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field v-model="IDDocs.number" label="Numero" :rules="[rules.required]" type="text"></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40"
                              transition="scale-transition" offset-y min-width="auto">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="IDDocs.expiration" label="Scadenza" :rules="[rules.required]" readonly v-bind="attrs" v-on="on">
                                </v-text-field>
                              </template>
                              <v-date-picker v-model="IDDocs.expiration" @input="menu = false" locale="it-IT"></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="6">
                            <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                              transition="scale-transition" offset-y min-width="auto">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="IDDocs.birthday" label="Data di nascita" readonly :rules="[rules.required]" v-bind="attrs" v-on="on">
                                </v-text-field>
                              </template>
                              <v-date-picker v-model="IDDocs.birthday" @input="menu2 = false" locale="it-IT"></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field v-model="IDDocs.birthplace" label="Luogo di nascita" :rules="[rules.required]"></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <!-- Documento di identità FINE -->

                <!-- Indirizzo INIZIO-->
                <v-expansion-panels accordion>
                  <v-expansion-panel>
                    <v-expansion-panel-header class="primary--text font-weight-bold">Indirizzo
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-container>
                        <v-row>
                          <v-col cols="12">
                            <v-text-field v-model="address.address" label="Indirizzo" :rules="[rules.required]"></v-text-field>
                          </v-col>

                          <v-col cols="6">
                            <v-text-field v-model="address.city" label="Città" :rules="[rules.required]"></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-autocomplete label="Comune" v-model="model" :search-input.sync="search"
                              :items="geoSearch" :loading="isLoading" hide-no-data return-object :rules="[rules.required]"></v-autocomplete>
                          </v-col>

                          <v-col cols="4">
                            <v-text-field v-model="address.cap" label="CAP" :rules="[rules.required]"></v-text-field>
                          </v-col>
                          <v-col cols="4">
                            <v-text-field v-model="address.province" label="Provincia" readonly></v-text-field>
                          </v-col>
                          <v-col cols="4">
                            <v-text-field v-model="address.region" label="Regione" readonly></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <!-- Indirizzo FINE-->
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="create">Salva</v-btn>
            <v-btn color="primary" @click="dismiss">Annulla</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  name: 'Create',
  props: {
    dialog: { type: Boolean, default: false },
  },

  data() {
    return {
      date: null,
      menu: false,
      menu2: false,
      valid: false,
      model: null,
      search: '',
      items: [],
      types: [
        'Carta d\'identità',
        'Patente',
        'Passaporto'
      ],
      isLoading: false,
      geoData: require('../../config/geo_data.json'),
      customer: {
        name: null,
        surename: null,
        phone: null,
        email: null,
        fiscal_code: null,
        note: null,
      },
      IDDocs: {
        type: null,
        number: null,
        municipality: null,
        province: null,
        birthday: null,
        expiration: null
      },
      address: {
        address: null,
        city: null,
        municipality: null,
        province: null,
        code: null,
        region: null,
        cap: null,
      },
      advanced: {
        mobile: null,
        fisso: null,
        brand_of_interest: null,
      },
      rules: {
        required: (value) => !!value || 'Campo obbligatorio.',
        validEmail: (value) => {
          if (value) {
            return (
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                value
              ) || 'Formato email non valido.'
            )
          } else {
            return true
          }
        },
        validFiscalCode: (value) => {
          if (value) {
            return (
              /^(?:[A-Z][AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i.test(
                value
              ) || 'Formato codice fiscale non valido.'
            )
          } else {
            return true
          }
        },
      },
      config: {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        },
      },
    }
  },

  computed: {
    geoSearch() {
      if (!this.search) return

      let res = []

      this.geoData.regioni.map((regione) => {
        regione.province.map((provincia) => {
          provincia.comuni.map((comune) => {
            if (comune.nome.toLowerCase().includes(this.search.toLowerCase())) {
              res.push(comune.nome)
            }
          })
        })
      })

      return res
    },
  },

  methods: {
    dismiss() {
      this.$emit('dismiss')
    },

    async create() {

      if (this.$refs.form.validate()) {
        const { data } = await axios.post(
          `${process.env.VUE_APP_API}/customers/create`,
          { address: this.address, IDDocs: this.IDDocs, customer: this.customer },
          this.config
        )

        if (data.status) {
          this.$emit('saved')
        }
      }
    },

    geoExtract(city) {
      let res = {}

      this.geoData.regioni.map((regione) => {
        regione.province.map((provincia) => {
          provincia.comuni.map((comune) => {
            if (comune.nome.toLowerCase() == city.toLowerCase()) {
              res = {
                regione: regione.nome,
                provincia: provincia.nome,
                codice: provincia.code,
                comune: comune.nome,
                cap: comune.cap,
              }
            }
          })
        })
      })

      return res
    },
  },

  watch: {
    model(city) {
      const res = this.geoExtract(city)

      this.address.region = res.regione
      this.address.province = res.provincia
      this.address.code = res.codice
      this.address.municipality = res.comune
      this.address.cap = res.cap
    },
  },
}
</script>

<style>
</style>
